<template lang="pug">
  modal(:overrideStyle='override' maxWidth='580px' @closeModal='closeAndRedirect')
    .modal-container.column.center.middle
      img.m4-bottom-6(:src='successIcon')
      .text-xbig.bold.m4-bottom-3
        | {{ $t('activeAccountModal.title') }}
      .text-big.text-message.dark-gray
        | {{ $t('activeAccountModal.message') }}
</template>

<script>
import { mapActions } from 'vuex'

import successIcon from '../../assets/il_mail_newpassword.svg'
import { routes } from '../../router'

import Modal from '../Modal'

export default {
  data() {
    return {
      activeAccountModal: {
        element: 'activeAccountModal'
      },
      successIcon
    }
  },
  computed: {
    override() {
      return { '--padding': '48px' }
    }
  },
  methods: {
    ...mapActions(['hideElement']),
    closeAndRedirect() {
      this.hideElement({ element: 'activeAccountModal' })
      this.$router.push({ name: routes.home })
    }
  },
  components: { Modal }
}
</script>

<style lang="scss" scoped>

.modal-container {
  height: 100%;
  margin: 12px 0;
  max-height: 400px;
  min-height: 230px;
  padding: 0 24px;
  width: 100%;
}

.text-message {
  min-width: 394px;
  text-align: center;
}

</style>
